import Cookies from 'js-cookie'

const TokenKey = 'account'
const StationKey = 'station'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function getStation() {
  return Cookies.get(StationKey)
}

export function setStation(station) {
  return Cookies.set(StationKey, station)
}

export function removeStation() {
  return Cookies.remove(StationKey)
}


// WEBPACK FOOTER //
// ./src/utils/auth.js